import { useRuntimeConfig } from '#imports'
import type { RouteRecordRaw } from 'vue-router'

import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'

import { GUEST } from './route-names'

export default (): RouteRecordRaw[] => {
  const { FF_ENABLE_GUEST_MY_ORDERS } = useRuntimeConfig().public

  const guestOrdersRoutes: RouteRecordRaw[] = [
    {
      name: GUEST.ORDERS,
      path: 'guest/orders',
      component: () =>
        import('~/scopes/guest/pages/guest-orders/GuestOrders.vue'),
      meta: {
        owners: ['bot-squad-sales-customer-care-front'],
        routeExists: () => FF_ENABLE_GUEST_MY_ORDERS === true,
        auth: {
          mode: 'guest-magic-link',
          redirection: { name: GUEST.ORDERS_RESEND_LINK },
        },
        tracking: { contentGroup: 'Account' },
        shoppingAssistant: { enabled: false },
      },
    },
    {
      name: GUEST.ORDERS_RESEND_LINK,
      path: 'guest/orders/resend-link',
      component: () =>
        import('~/scopes/guest/pages/guest-orders-resend-link/GuestOrdersResendLink.vue'),
      meta: {
        layout: 'minimal',
        owners: ['bot-squad-sales-customer-care-front'],
        routeExists: () => FF_ENABLE_GUEST_MY_ORDERS === true,
        tracking: { contentGroup: 'Account' },
        shoppingAssistant: { enabled: false },
      },
    },
  ]

  const guestUpgradeRoute: RouteRecordRaw = {
    name: GUEST.UPGRADE,
    path: 'guest/upgrade',
    component: () =>
      import('~/scopes/guest/pages/guest-upgrade/GuestUpgrade.vue'),
    meta: {
      auth: {
        mode: 'guest-magic-link',
        redirection: { name: GUEST.UPGRADE_RESEND_LINK },
      },
      layout: 'minimal',
      owners: ['bot-squad-identity'],
      tracking: { contentGroup: 'Account' },
      shoppingAssistant: { enabled: false },
    },
  }

  const guestUpgradeResendLinkRoute: RouteRecordRaw = {
    name: GUEST.UPGRADE_RESEND_LINK,
    path: 'guest/upgrade/resend-link',
    component: () =>
      import('~/scopes/guest/pages/guest-upgrade-resend-link/GuestUpgradeResendLink.vue'),
    meta: {
      layout: 'minimal',
      owners: ['bot-squad-identity'],
      tracking: { contentGroup: 'Account' },
      shoppingAssistant: { enabled: false },
    },
  }

  const webviewRoutes = generateWebviewRoutes([guestUpgradeRoute])

  return [
    ...guestOrdersRoutes,
    guestUpgradeRoute,
    guestUpgradeResendLinkRoute,
    ...webviewRoutes,
  ]
}
